import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sections", "buttonText"]

  connect() {
    this.collapsed = false
  }

  toggleAll() {
    this.collapsed = !this.collapsed

    this.sectionsTargets.forEach((section) => {
      // Get the toggle controller instance attached to this section
      const toggleController = this.application.getControllerForElementAndIdentifier(section, "toggle")
      if (!toggleController) return

      if (this.collapsed) {
        toggleController.collapse()
      } else {
        toggleController.expand()
      }
    })

    // Update button text
    if (this.hasButtonTextTarget) {
      this.buttonTextTarget.textContent = this.collapsed ? "Expand All" : "Collapse All"
    }
  }
}